import type { RefObject } from "react";

export const getFormBody = (
  editorRef?: RefObject<HTMLDivElement> | null,
  fallbackElement?: HTMLElement | null
) =>
  editorRef?.current?.outerHTML ??
  fallbackElement?.closest("form")?.outerHTML ??
  fallbackElement?.outerHTML ??
  "";